export { default } from "./google-ad-sense"
